// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"db5b906d","977":"ace39ac5"}[chunkId] + ".chunk.js";
};